import type { PropsWithChildren } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { ArrowLeftIcon } from 'lucide-react'

export const StepperHeader = ({
	children,
	className,
	onClickBack,
}: PropsWithChildren<{
	onClickBack: () => void
	className?: string
}>) => {
	const { t } = useLingui()

	return (
		<div
			className={cn(
				'sticky top-0 z-10 flex h-[60px] flex-row items-center justify-between bg-white px-4 text-center text-lg font-bold',
				className,
			)}
		>
			<Button
				className='size-8'
				icon
				onClick={onClickBack}
				type='button'
				variant='ghost'
				aria-label={t`Revenir à l'étape précédente`}
			>
				<ArrowLeftIcon className='text-foreground !size-5' />
			</Button>

			{children}

			<div className='size-8' />
		</div>
	)
}
